import React from "react";

export const FARM_RAIN_HISTORY_HELP_TITLE = "Histórico de chuva e clima";

export function FarmRainHistoryHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Acompanhar a{" "}
        <strong>chuva registrada na fazenda</strong> e o{" "}
        <strong>clima da sede</strong> (temperatura, vento e umidade) ao longo
        do tempo.
      </p>

      <p>
        <strong>Duas telas:</strong> no topo, o ícone de <strong>chuva</strong>{" "}
        abre o mapa e o histórico dos pluviômetros. O ícone de{" "}
        <strong>clima</strong> abre temperatura, umidade e vento da fazenda,
        com gráficos do dia ou da semana.
      </p>

      <p>
        <strong>Clima da fazenda:</strong> a plataforma grava sozinha a cada{" "}
        <strong>10 minutos</strong> no centro da propriedade, mesmo sem máquina
        no campo. Esse registro alimenta o pop-up do rastreamento quando o
        trabalho acontece <strong>dentro da cerca</strong>. Fora da fazenda, o
        rastro usa o clima do app, com a hora da última atualização.
      </p>

      <p>
        <strong>Pluviômetros espalhados pela fazenda:</strong> você pode ter
        vários pontos de coleta (cantos, centro, sub-fazendas). Cada um fica
        vinculado à posição GPS cadastrada.
      </p>

      <p>
        <strong>Como alimentar os dados (app de campo):</strong> o colaborador
        informa a <strong>quantidade de chuva (mm)</strong> diretamente no app.
        Pela <strong>geolocalização do celular</strong>, a plataforma{" "}
        <strong>reconhece automaticamente</strong> qual pluviômetro está mais
        próximo — não é preciso selecionar o ponto manualmente.
      </p>

      <p>
        <strong>O que aparece aqui na plataforma web:</strong>
      </p>
      <ul>
        <li>leituras registradas por pluviômetro e por período;</li>
        <li>planilha com histórico diário de cada ponto;</li>
        <li>
          <strong>mapa de calor (heatmap)</strong> mostrando como a chuva se
          distribuiu pela fazenda.
        </li>
      </ul>

      <p>
        <strong>Cadastro de pluviômetros:</strong> o ponto é criado{" "}
        <strong>no app de campo</strong>, na posição GPS. Mantenha pelo menos{" "}
        <strong>100 m entre pontos</strong> para o reconhecimento automático
        funcionar bem (até <strong>60 m</strong> de tolerância).
      </p>

      <p>
        <strong>Lançamento manual na plataforma:</strong> se alguém anotar a
        chuva no papel, o gestor lança ou corrige os <strong>mm</strong> aqui
        (lápis do ponto ou célula da planilha). Também dá para{" "}
        <strong>excluir</strong> um pluviômetro e filtrar por{" "}
        <strong>hoje, semana, mês ou data personalizada</strong>.
      </p>

      <p>
        <strong>Zoom do mapa:</strong> a tela abre perto dos pluviômetros, não
        na escala do país. Ajuste posição e zoom e clique em{" "}
        <strong>Salvar tela</strong> — este navegador reabre do jeito que você
        deixou.
      </p>
    </>
  );
}
